import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: 'What is SEO and why do I need it?',
  answer: 'SEO (Search Engine Optimization) is the process of improving your website to rank higher in search results like Google. You need it because higher rankings mean more visibility, more traffic, and ultimately more customers without paying for every click.'
}, {
  question: 'How long does SEO take to show results?',
  answer: 'SEO is a long-term strategy. Typically, you can expect to see initial improvements in 3-4 months, with significant results in 6-12 months. However, this varies based on your industry competition and current website state.'
}, {
  question: "What's the difference between SEO and PPC?",
  answer: 'SEO focuses on earning traffic through organic (unpaid) search results, while PPC (Pay-Per-Click) involves buying traffic through paid ads. SEO takes time but offers long-term value; PPC offers immediate results but stops when you stop paying.'
}, {
  question: 'How much do your services cost?',
  answer: 'We offer custom packages tailored to your business needs and goals. Contact us on WhatsApp for a free consultation and a bespoke quote based on your requirements.'
}, {
  question: 'Do you work with small businesses?',
  answer: 'Yes! We work with businesses of all sizes, from local startups to large national enterprises. We scale our strategies to fit your budget and growth targets.'
}, {
  question: 'How do I get started?',
  answer: 'It’s simple! Just click the WhatsApp button to chat with us. We’ll discuss your goals, audit your current presence, and propose a strategy to move forward.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-slate-50" data-id="element-23">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-26">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600" data-id="element-27">
            Everything you need to know about our services and process.
          </p>
        </div>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-slate-200 overflow-hidden transition-all duration-200" data-id="element-29">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center p-6 text-left focus:outline-none" data-id="element-30">
                <span className="text-lg font-semibold text-slate-900" data-id="element-31">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-emerald-500" data-id="element-32" /> : <ChevronDown className="w-5 h-5 text-slate-400" data-id="element-33" />}
              </button>
              <div className={`px-6 text-slate-600 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-34">
                {faq.answer}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}